import { acceptedProductVisualMimetypes, FileType, supportedDocumentFileTypes, supportedImageFileTypes } from 'constants/misc'

/**
 * The file types each kind of client upload accepts, matching the legacy purchase flow area by area.
 */

/** Visuals handed over for editing (`EditingProductUpload`). */
export const EDITING_FILE_TYPES = Object.values(acceptedProductVisualMimetypes).flat() as FileType[]

/** The plan a floor plan is drawn from, which may also be a PDF (legacy `acceptedProductVisualMimetypesWithPDF`). */
export const FLOOR_PLAN_SOURCE_FILE_TYPES = [...EDITING_FILE_TYPES, FileType.PDF]

/** A document product's source, such as the plan a floor-plan certification is made from (`DocumentProductUpload`). */
export const DOCUMENT_SOURCE_FILE_TYPES = [...supportedImageFileTypes, ...supportedDocumentFileTypes]
